import { post } from './client';
import { buildPath, toJson } from './utils';
import { DEEPLINK_BASE_PATH } from './constants';

export const entry = (options: any): Promise<any> =>
  post(buildPath(DEEPLINK_BASE_PATH, 'entry/'), options).then(toJson);

export const linkAccount = (options: any): Promise<any> =>
  post(buildPath(DEEPLINK_BASE_PATH, 'auth', 'link/'), options).then(toJson);

export const conflictResolve = (options: any): Promise<any> =>
  post(buildPath(DEEPLINK_BASE_PATH, 'conflict-resolve/'), options).then(toJson);
